/* istanbul ignore file */
export const FILE_PICKER_CHANGE_EVENT = 'change'
